/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import worldMap from '../../data/world-110m-sans-antarctica';
import usStates from '../../data/states-10m';
import Map from './map';
import { Legend } from './legend';
import { mapStyles } from './styles';

export function USMap({ data, dimensions, showLegend }) {
	const { width, height } = dimensions;
	const max = d3.max(Object.values(data), (d) => +d.value);

	return (
		<div cy-test="us-map-data" css={mapStyles.wrapper}>
			<Map
				projection="geoAlbersUsa"
				shapes={usStates}
				data={data}
				max={max}
				dataMapper={(geography) => (data[geography.properties.name] ? data[geography.properties.name].value : 0)}
				dimensions={{
					height: height,
					width: width,
				}}
				center={[-97, 37]}
				legend={showLegend && <Legend dimensions={{ width, height: 40 }} maxValue={max} />}
			/>
		</div>
	);
}

USMap.propTypes = {
	data: PropTypes.any,
	dimensions: PropTypes.any,
	showLegend: PropTypes.bool,
};

export function WorldMap({ data, dimensions, showLegend }) {
	const { width, height } = dimensions;

	const max = d3.max(Object.values(data), (d) => +d.value);

	return (
		<div cy-test="world-map-data" css={mapStyles.wrapper}>
			<Map
				projection="geoEqualEarth"
				shapes={worldMap}
				data={data}
				max={max}
				dataMapper={(geography) => {
					if (data[geography.properties.name]) {
						return data[geography.properties.name].value;
					} else if (data[geography.properties.nameLong]) {
						return data[geography.properties.nameLong].value;
					}
					return 0;
				}}
				dimensions={{
					height: height,
					width: width,
				}}
				center={[0, 0]}
				legend={showLegend && <Legend dimensions={{ width, height: 40 }} maxValue={max} />}
			/>
		</div>
	);
}

WorldMap.propTypes = {
	data: PropTypes.any,
	dimensions: PropTypes.any,
	showLegend: PropTypes.bool,
};
